module.exports = __webpack_public_path__ + "static/media/icon_light_bulb.2ae5448f.svg";